import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45e6a38c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Список заказ-нарядов", -1))
const _hoisted_3 = { class: "base-form filter" }
const _hoisted_4 = { class: "base-form filter" }
const _hoisted_5 = { class: "lr-margin-container" }
const _hoisted_6 = { class: "base-form filter" }
const _hoisted_7 = { class: "base-form filter" }
const _hoisted_8 = { class: "base-form filter" }
const _hoisted_9 = { class: "base-form filter" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CirclePlus = _resolveComponent("CirclePlus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_counterparty_filter_component = _resolveComponent("counterparty-filter-component")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_order_status_selector_component = _resolveComponent("order-status-selector-component")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_order_print_form_component = _resolveComponent("order-print-form-component")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_scrollview_component = _resolveComponent("scrollview-component")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 18 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                size: "large",
                onClick: _ctx.onCreateOrderClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { size: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CirclePlus)
                    ]),
                    _: 1
                  }),
                  _createTextVNode("   Новый заказ-наряд ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ordersSearchFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ordersSearchFilter) = $event)),
                clearable: "",
                max: "250",
                placeholder: "Поиск заказ-нарядов по номеру, контрагенту, менеджеру, VIN или гос. номеру",
                onInput: _ctx.fetchOrders
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "onInput"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_date_picker, {
                style: {"box-sizing":"border-box"},
                modelValue: _ctx.ordersDateRangeFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ordersDateRangeFilter) = $event)),
                clearable: false,
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "Дата начала",
                "end-placeholder": "Дата окончания",
                format: "DD.MM.YYYY",
                onChange: _ctx.fetchOrders
              }, null, 8, ["modelValue", "onChange"]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.predefinedDatesRangeFilters, (f) => {
                  return (_openBlock(), _createBlock(_component_el_link, {
                    underline: false,
                    key: f.days,
                    type: f.active ? 'primary' : 'info',
                    onClick: () => _ctx.onPredefinedDateRangeFilterClick(f.days)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(f.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "onClick"]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.ordersManagersFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ordersManagersFilter) = $event)),
                placeholder: "Фильтровать заказ-наряды по менеджерам",
                onChange: _ctx.fetchOrders,
                multiple: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managers, (m) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: m.id,
                      value: m.id,
                      label: `${m.lastname} ${m.firstname.substring(0,1)}.`
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.ordersStatusesFilter,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ordersStatusesFilter) = $event)),
                multiple: true,
                placeholder: "Фильтровать заказ-наряды по статусам",
                onChange: _ctx.fetchOrders,
                "collapse-tags": "",
                "collapse-tags-tooltip": ""
              }, {
                label: _withCtx(({ value }) => [
                  _createTextVNode(_toDisplayString(_ctx.statusesDescriptions[value]), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.ordersBranchesFilter,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ordersBranchesFilter) = $event)),
                clearable: "",
                multiple: true,
                placeholder: "Фильтр по подразделению",
                onChange: _ctx.fetchOrders
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employerBranches, (p) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: p.id,
                      value: p.id,
                      label: p.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_counterparty_filter_component, {
                ref: "counterpartyFilterComponent",
                onSelected: _ctx.onCounterpartyFilterChanged
              }, null, 8, ["onSelected"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_scrollview_component, { "min-height": "220" }, {
              default: _withCtx(({ height }) => [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  ref: "ordersTable",
                  height: height,
                  "show-summary": "",
                  data: _ctx.ordersList,
                  "highlight-current-row": "",
                  "summary-method": _ctx.calculateTotal,
                  onRowDblclick: _ctx.onTableRowDblClick,
                  onSortChange: _ctx.onTableSortChange,
                  "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortDir }
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_el_text, { type: "info" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Список заказ-нарядов пуст ☹️")
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      prop: "date",
                      "column-key": "date",
                      label: "Дата"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(_ctx.dateFormatter(scope.row.date, true)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      prop: "number",
                      label: "№",
                      "column-key": "number"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_link, {
                          underline: false,
                          onClick: (e) => _ctx.onTableOrderNumberClick(scope.row, e),
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.number), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      sortable: "",
                      "column-key": "statusid",
                      label: "Статус"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_order_status_selector_component, {
                          "parent-scrollable-element": _ctx.tableScollElement,
                          "forward-flow": true,
                          cancellable: true,
                          disabled: scope.row.isAsyncOperationPending,
                          status: scope.row.status,
                          onChange: (newStatusId) => _ctx.onTableOrderStatusChange(scope.row, newStatusId)
                        }, null, 8, ["parent-scrollable-element", "disabled", "status", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "manager",
                      label: "Менеджер",
                      sortable: "",
                      "column-key": "managerId"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          onClick: (e) => _ctx.onTableManagerCellClick(e, scope.row.manager)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(`${scope.row.manager.lastname} ${scope.row.manager.firstname?.substring(0,1)}.`), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "customer",
                      label: "Заказчик",
                      sortable: "",
                      "column-key": "customerId"
                    }, {
                      default: _withCtx((scope) => [
                        (!scope.row.customer?.legalEntity)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              type: "primary",
                              onClick: (e) => _ctx.onTableCustomerCellClick(e, scope.row.customer)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(`${scope.row.customer.lastname} ${scope.row.customer.firstname}`), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_el_link, {
                              key: 1,
                              type: "primary",
                              onClick: (e) => _ctx.onTableCustomerCellClick(e, scope.row.customer)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row.customer.legalEntity.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "vehicle",
                      label: "Автомобиль"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.vehicle.govermentalNumber)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(scope.row.vehicle.govermentalNumber) + ", " + _toDisplayString(`${scope.row.vehicle?.model?.manufacturer?.name} ${scope.row.vehicle?.model?.name}`), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(`${scope.row.vehicle?.model?.manufacturer?.name} ${scope.row.vehicle?.model?.name}`), 1)),
                        (scope.row.vehicle.vin)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_el_text, {
                                type: "info",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.vehicle.vin), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createTextVNode("   "),
                              _createVNode(_component_el_link, {
                                type: "primary",
                                onClick: (e) => _ctx.onTableVINCopyClick(scope.row.vehicle.vin, e),
                                underline: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CopyDocument)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      formatter: _ctx.tableOrderTotalCostFormatter,
                      label: "Итого (руб.)",
                      "column-key": "orderTotal"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, { width: "100" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_order_print_form_component, {
                          "order-id": scope.row.id,
                          "icon-only": ""
                        }, null, 8, ["order-id"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["height", "data", "summary-method", "onRowDblclick", "onSortChange", "default-sort"])), [
                  [_directive_loading, _ctx.tableLoading]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}